import { Component, Event, Prop, h, type EventEmitter, Listen } from '@stencil/core';
import type { IConversationalSearchStrategyData } from '../../../strategies/types/conversational-search-srategy-data.type';
import * as storageHelpers from '../conversational-search-logic/storage-manager/storage-manager-helpers';
import { handleInvocationUrlChanges, handleExternalOriginParam } from './conversational-search-chat-elements-wrapper-helpers';
import type { labelProviderInterface } from '../../../LabelProviderInterface';

@Component({
  tag: 'uiaas-search-widget-conversational-search-chat-elements-wrapper',
  styleUrl: 'conversational-search-chat-elements-wrapper.scss',
  shadow: true,
})
export class WidgetConversationalSearchChatElementsWrapper {
  @Prop() readonly conversationalSearchStrategyData: IConversationalSearchStrategyData['params'];
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly language: string;
  @Prop() readonly country: string;
  @Prop() readonly query: string;
  @Prop() readonly apigeeAuth: string;
  @Prop() readonly apigeeTokenUrl: string;

  @Event({
    eventName: 'conversational-search:cta-action',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    conversationalSearchCtaActionEventEmitter: EventEmitter<{ isChatVisible: boolean }>;

  @Listen('guided:SearchCompleted', { target: 'window' })
  handleReloadAndSubmitAction() {
      if (!storageHelpers.getTermsAndConditionsSessionStorageValue() && storageHelpers.getUIDSessionStorageValue()) {
        // Refresh token for not accepting terms and conditions and changed query
        storageHelpers.removeUIDSessionStorageValue();
      }
  }

  @Listen('beforeunload', { target: 'window' })
  handleReload() {
      storageHelpers.removeChatActionSessionStorageValue();
      storageHelpers.removeUIDSessionStorageValue();

      // Assure that Guided Search case will not remove CTA action from session storage
      if (!storageHelpers.getChatVisibilitySessionStorageValue()) storageHelpers.removeCTAActionSessionStorageValue();
  }

  @Listen('conversational-search:user-new-conversation', { target: 'window' })
  userNewConversationHandler() {
      storageHelpers.removeUIDSessionStorageValue();
  }

  async componentWillLoad() {
      /**
      * This logic is added to allow user launch genAI with special &genai=true URL param
      * Adding this param will also change UI of GenAI preventing going to see SRP page
      * Because of that, we need to store URL with this UI is triggered (after removing genai param), and if this URL will change, we are resetting everything to default view
      * It can not be achieve by using state, listening on popstate or beforeunload because, it will be not detecting changes in URL param or it will reset on page refresh
      * IT IS ONLY TEMPORARY SOLUTION - IT WILL BE REMOVED WHEN SPECIAL PAGE FOR GENAI WILL BE CREATED OR HOMEPAGE WILL ADD INPUT FOR GENAI BANNER!
      * To know more, please visit documentation for genAi in confluence under UIaaS documentation folder/category!
      */
      handleInvocationUrlChanges();
      handleExternalOriginParam(
        this.conversationalSearchStrategyData.isConversationalSearchActive,
        this.conversationalSearchCtaActionEventEmitter
      );
  }

  render() {
      return this.conversationalSearchStrategyData.isConversationalSearchActive ? (
        <section class="conversational-search-chat-elements-wrapper">
          <uiaas-search-widget-conversational-search-chat-widget
            labelProvider={(e, f) => this.labelProvider(e, f)}
            country={this.country}
            language={this.language}
            searchQuery={this.query}
            apigeeAuth={this.apigeeAuth}
            apigeeTokenUrl={this.apigeeTokenUrl}
            conversationalSearchProductsEndpoint={this.conversationalSearchStrategyData.conversationalSearchProductsEndpoint}
            conversationalSearchMedaliaFormId={this.conversationalSearchStrategyData.conversationalSearchMedaliaFormId}
            conversationalSearchBrandUrl={this.conversationalSearchStrategyData.conversationalSearchBrandUrl}
          />
          <uiaas-search-widget-conversational-search-overlay labelProvider={(e, f) => this.labelProvider(e, f)} />
        </section>
      ) : '';
  }
}
